/**
 * goToChannelsGrid action.
 */
import Channel from '../../classes/channel';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

interface Props {
  channel?: Channel;
  push?: boolean;
}

export default function goToChannelsGrid({ channel }: Props = {}) {
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CHANNELS_GRID, overwrite: true },
      params: {
        current: {
          channel,
        },
      },
    })
  );
}
